<template>
  <div>
    <span v-if="condition">{{ $t(yes) }}</span>
    <span v-if="!condition">{{ $t(no) }}</span>
  </div>
</template>

<script>
export default {
  name: 'text-yes-no',
  props: {
    yes: {
      default: 'yes'
    },
    no: {
      default: 'no'
    },
    condition: {}
  }
}
</script>
